import React from "react";
import { FaUserTie, FaTools, FaAward } from "react-icons/fa";

function WhyChooseUs() {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section id="about" className="py-0">

      {/* ⭐ FULL WIDTH BLACK BACKGROUND */}
      <div className="w-full bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white py-12 sm:py-16 md:py-20">

        {/* ⭐ CENTERED CONTENT INSIDE BLACK BG */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">

          <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">

            {/* === LEFT SIDE (3D CAROUSEL) === */}
            <div
              className="flex flex-col items-center md:items-start animate-fade-in order-2 md:order-1 w-full"
              data-aos="fade-right"
            >
              <div
                className="overflow-hidden w-full rounded-xl sm:rounded-2xl"
                style={{
                  overflow: "hidden",
                  position: "relative",
                  perspective: "1200px",
                  height: "500px",
                }}
              >
                <div
                  className="overflow-hidden w-full rounded-xl sm:rounded-2xl h-full"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                    perspective: "1200px",
                    height: "650px",
                  }}
                >
                  {/* Your Image Items */}
                  {[
                    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=500&h=400&fit=crop",
                    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=400&fit=crop",
                    "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=500&h=400&fit=crop",
                    "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=500&h=400&fit=crop",
                    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=500&h=400&fit=crop",
                    "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=500&h=400&fit=crop",
                  ].map((src, i) => (
                    <div className="carousel-item-3d" style={{ marginRight: "2rem" }} key={i}>
                      <img
                        src={src}
                        alt="Team Image"
                        className="rounded-xl sm:rounded-2xl shadow-2xl h-56 sm:h-64 md:h-72 object-cover"
                        style={{ width: "400px", display: "block" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* === RIGHT SIDE (TEXT + FEATURES) === */}
            <div
              className="space-y-6 sm:space-y-7 md:space-y-8 text-center md:text-left animate-fade-in order-1 md:order-2"
              data-aos="fade-left"
            >
              <div>
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent leading-tight">
                  Why Choose Us
                </h2>
                <div className="w-16 sm:w-20 md:w-24 h-0.5 sm:h-1 bg-gradient-to-r from-blue-500 to-purple-500 mb-4 sm:mb-6 md:mx-0 mx-auto"></div>
              </div>

              <p className="text-gray-300 mb-6 sm:mb-8 text-sm sm:text-base md:text-lg leading-relaxed px-2 sm:px-0">
                Empowering the future with sustainable energy and smart automation.
                We provide advanced Solar Panel Solutions and Robotics Services that
                drive efficiency, innovation, and environmental responsibility.
              </p>

              <ul className="space-y-4 sm:space-y-5 md:space-y-6">
                <li className="flex items-center space-x-3 sm:space-x-4 group">
                  <span className="bg-gradient-to-br from-blue-500 to-purple-600 text-white p-3 sm:p-3.5 md:p-4 rounded-xl sm:rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300 ease-in-out flex-shrink-0">
                    <FaUserTie size={20} />
                  </span>
                  <span className="text-base sm:text-lg font-semibold group-hover:text-blue-400 transition-colors duration-300">
                    Professional Guidance
                  </span>
                </li>

                <li className="flex items-center space-x-3 sm:space-x-4 group">
                  <span className="bg-gradient-to-br from-green-500 to-teal-600 text-white p-3 sm:p-3.5 md:p-4 rounded-xl sm:rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300 ease-in-out flex-shrink-0">
                    <FaTools size={20} />
                  </span>
                  <span className="text-base sm:text-lg font-semibold group-hover:text-green-400 transition-colors duration-300">
                    Professional Technicians
                  </span>
                </li>

                <li className="flex items-center space-x-3 sm:space-x-4 group">
                  <span className="bg-gradient-to-br from-yellow-500 to-orange-600 text-white p-3 sm:p-3.5 md:p-4 rounded-xl sm:rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300 ease-in-out flex-shrink-0">
                    <FaAward size={20} />
                  </span>
                  <span className="text-base sm:text-lg font-semibold group-hover:text-yellow-400 transition-colors duration-300">
                    10+ Years of Experience
                  </span>
                </li>
              </ul>

              <div className="pt-4 sm:pt-6">
                <button
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold px-6 sm:px-8 py-3 sm:py-3.5 md:py-4 rounded-lg hover:from-blue-600 hover:to-purple-700 active:from-blue-700 active:to-purple-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
                >
                  Get Started
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
